/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */
import * as React from 'react'
import ReactDOM from 'react-dom/client'
import { StartClient } from '@tanstack/react-start'
import { createRouter } from './router'
import './styles.css';

const user = window.__user__;
const router = createRouter(user.isLoggedIn, false);

ReactDOM.hydrateRoot(document, <StartClient router={router} />)
